import { AuthenticationService } from '../services/authentication.service';
import * as i0 from "@angular/core";
import * as i1 from "../services/authentication.service";
var NotLoggedInGuard = /** @class */ (function () {
    function NotLoggedInGuard(authService) {
        this.authService = authService;
    }
    NotLoggedInGuard.prototype.canActivate = function (next, state) {
        return this.authService.checkLogout();
    };
    NotLoggedInGuard.ngInjectableDef = i0.defineInjectable({ factory: function NotLoggedInGuard_Factory() { return new NotLoggedInGuard(i0.inject(i1.AuthenticationService)); }, token: NotLoggedInGuard, providedIn: "root" });
    return NotLoggedInGuard;
}());
export { NotLoggedInGuard };
